import { Company } from 'generated/apolloComponents'
import CompanyHeaderInfo from '@/components/molecules/CompanyHeaderInfo'
import styles from '../Company.module.scss'
import NavTabs from '@/components/molecules/NavTabs'

type ListItem = {
  title: string
  url: string
  slug: string
}

type Props = {
  emptyCover: boolean
  company: Company
  menu: ListItem[] | {}[]
  navRefs: any
}

const ProfessionalLayout = ({ emptyCover, company, menu, navRefs }: Props) => {
  const color = company?.themeColor || '#eff5f5'

  if (!company?.currentLayout) {
    return null
  }

  return (
    <>
      <div
        style={{
          backgroundColor: company.themeColor
            ? company.themeColor
            : 'transparent',
        }}
      >
        <div
          className={`${
            !emptyCover
              ? styles.company__cover
              : styles['company__cover--basic']
          } relative container`}
        >
          {company.coverPhoto && company.coverPhoto.url && !emptyCover && (
            <div className={`${styles.company__cover__image} rounded-t-xl`}>
              <img
                className='w-full'
                src={company.coverPhoto.url}
                width={company.coverPhoto.width as number}
                height={company.coverPhoto.height as number}
                alt={company.name}
              />
            </div>
          )}
        </div>
      </div>
      <div className='container'>
        <CompanyHeaderInfo
          company={company}
          color={color}
          layout={company.currentLayout}
          emptyCover={emptyCover}
          headerTheme={!emptyCover ? 'light' : 'dark'}
        />
      </div>
      <div
        className={`lg:sticky mx-auto lg:container z-70 relative ${styles.company__nav__container}`}
      >
        <div className={`${styles.company__nav} bg-white  lg:rounded-b-xl `}>
          <NavTabs
            className='flex'
            color={color}
            data={menu}
            navRefs={navRefs}
          />
        </div>
      </div>
    </>
  )
}

export default ProfessionalLayout
